import * as React from 'react';
import { connect } from 'react-redux';
import { createRouteNodeSelector } from 'redux-router5';
import { navigate } from '~/router';

import { UserRole } from '~/apps/shared/consts';
import SideMenu from '~/common/menu/SideMenu';


function SideMenuContainer(props) {
  const { auth, route } = props;

  let items = [];

  if (!auth.loading && auth.currentUser) {
    items = [
      {
        iconClass: 'i-code',
        text: 'Codes',
        isActive: route.name.startsWith('sender.paycodes'),
        onClick: (e) => navigate('sender.paycodes'),
      },
      {
        iconClass: 'i-dollar',
        text: 'Payments',
        isActive: route.name.startsWith('sender.transactions'),
        onClick: (e) => navigate('sender.transactions'),
      },
      {
        iconClass: 'i-cog',
        text: 'Settings',
        isActive: route.name.startsWith('sender.settings'),
        onClick: (e) => navigate('sender.settings'),
      },
    ];
  }

  return (
    <SideMenu items={items} />
  );
};


const mapStateToProps = (state) => {
  const routeNodeSelector = createRouteNodeSelector('sender');

  return {
    auth: state.shared.auth,
    ...routeNodeSelector(state),
  }
};

export default connect(mapStateToProps)(SideMenuContainer);
